<div class="contractor-list-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToDashboard()">
      {{ pageTitleEnum.VendorManagement }} / {{ pageTitleEnum.ContractorList }}
    </span>
  </div>

  <div class="contractor-list-container">
    <div class="contractor-search-table-container">
      <div class="contractor-list-search">
        <div class="contractor-title">
          <span>List of Contractors ({{ totalCount }})</span>
        </div>
        <div class="search-bar-container">
          <div class="search-child">
            <emerald-input
              [label]="'Search'"
              [trailingIcon]="'search'"
              (keyup)="searchContractors($event)"
              [value]="filterValue"
              ><emerald-icon
                *ngIf="filterValue?.length"
                [icon]="'close'"
                (click)="clearInput()"
              ></emerald-icon>
            </emerald-input>
          </div>

          <emerald-menu
            *ngIf="selectedTab?.label === tabLabel.orgView"
            [opened]="opened"
            [position]="'bottom_end'"
            [targetElement]="navTemplate"
            [menuTemplate]="menuTemplate"
            (openChange)="opened = $event"
          ></emerald-menu>
          <ng-template #navTemplate>
            <emerald-button
              [label]="'Filter'"
              [size]="'Small'"
              [type]="'Secondary'"
              [icon]="'filter_list'"
              [iconPosition]="'Left'"
              (onClick)="this.opened = !this.opened"
            ></emerald-button>
          </ng-template>
          <ng-template #menuTemplate>
            <app-contractor-filter
              *ngIf="selectedTab?.label === tabLabel.orgView"
              [fieldsVisibility]="fieldsVisibility"
              [contractorDataByOrgView]="rowData"
              (filterApplied)="onFilterApplied($event)"
              (closeModal)="opened = false"
            ></app-contractor-filter>
          </ng-template>

          <div class="navigation-tabs-container">
            <emerald-tab-bar
              [tabsData]="tabsData"
              class="custom-green"
              [showContent]="true"
              (selectedTabChange)="onTabChange($event)"
            >
            </emerald-tab-bar>
          </div>
        </div>
      </div>

      <div
        class="contractor-list-table"
        *ngIf="selectedTab?.label === tabLabel.orgView"
      >
        <ng-container *ngIf="displayData?.length; else noDataTemplate">
          <emerald-datatable
            [columnDefs]="columnDefs"
            [rowData]="displayData"
            [paginationParams]="paginationParams"
            [customCellTemplate]="{
              contractorName: customContractorNameColumn,
            }"
          >
          </emerald-datatable>
        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <ng-container *ngIf="isDataLoaded">
                <h2 class="empty-state-title">{{ errorMsg }}</h2>
              </ng-container>
              <img
                [src]="imageSrc"
                alt="No records illustration"
                class="empty-state-image"
              />
            </div>
          </section>
        </ng-template>
        <ng-template
          #customContractorNameColumn
          let-level="level"
          let-eachRow="eachRow"
        >
          <div class="contractor-info">
            <a
              class="name"
              (click)="navigateToContractorProfile(eachRow.contractorId)"
              >{{ eachRow?.contractorName }}</a
            >
            <span class="designation">{{ eachRow?.designation }}</span>
          </div>
        </ng-template>
      </div>

      <app-contractors-managers-view
        *ngIf="selectedTab?.label === tabLabel.managerView"
        [filterKeyword]="filterValue"
        (totalCount)="onManagerViewTotalCount($event)"
      ></app-contractors-managers-view>
    </div>
  </div>
</div>
<app-modal-wrapper *ngIf="showContractorProfile" [showModal]="showContractorProfile">
  <app-contractor-profile
    [contractorId]="contractorId"
    (close)="showContractorProfile = false; contractorId = ''"
  ></app-contractor-profile>
</app-modal-wrapper>
